import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div data-testid="protected-loading" className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
        <div className="text-white/40 text-sm font-mono uppercase tracking-widest">Φόρτωση...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/dashboard/login" replace />;
  return children;
}
